/** 数据修正 */
export default {
    openId: "open id", // 开放id
    openIdPlaceholder: "open id", // 请输入开放id
    organisation: "organisation", // 组织架构
    organisationName: "organisation name", // 组织名称 organisation name
    organisationNamePlaceholder: "organisation name", // 请输入组织名称 
    affiliatedOrganisation: "affiliated organisation", // 所属组织
    entity: "store", // 实体
    entityId: "entity id", // 实体id
    entityName: "store name", // 实体名称 entity name
    entityNamePlaceholder: "store name", // 请输入实体名称
    sortNumber: "sort number", // 实体排序
    entityType: "store type", // 实体类型
    businessHours: "Business hours", // 营业时间
    businessStartTime: "Business start time", // 营业开始时间
    closingTime: "closing time", // 营业结束时间
    passagewayName: "door name", // 出入口名称 Entry and exit management
    passagewayNamePlaceholder: "door name", // 请输入出入口名称
    maximumCapacity: "Maximum capacity", // 最大容纳人数
    maxInstant: "max instant", // 最大瞬时人数
    inWarningNum: "in warning num", // 预警进人数
    passengerBasic: "passenger basic", // 客流基数
    totalPassenger: "total passenger", // 总客流人数
    today: "to day", // 今日日期
    storePhone: "store phone", // 门店电话
    linker: "linker", // 联系人姓名
    linkerPlaceholder: "linker", // 请输入联系人姓名
    address: "address", // 详细地址
    linkerPhone: "linker phone", // 联系人手机
    entryNumber: "walk into", // 进人数 walk into
    exitNumber: "walk out", // 出人数 walk out
    passingsNumber: "walk pass", // 经过人数 walk pass
    returnNumber: "walk return", // 折返人数
    manNumber: "man number", // 男客流量
    girlNumber: "girl number", // 女客流量
    strandNumber: "people staying", // 滞留人数 people staying
    whetherToCalculate: "Whether to calculate", // 是否需要计算 Whether to calculate
    needToCalculate: "need to calculate", // 需要计算
    noNeedToCalculate: "No need to calculate", // 不需要计算
    currentOneMinute: "current one minute", // 一分钟时间
    currentFiveMinute: "current five minute", // 所在五分钟
    currentHour: "current hour", // 所在小时
    currentDate: "current date", // 所在天
    currentWeek: "current week", // 所在周
    currentMonth: "current month", // 所在月
    currentYear: "current year", // 所在年
    searchTime: "search time", // 搜索时间
    startTime: "start time", // 开始时间
    endTime: "end time", // 结束时间
    serialNumber: "serial number", // 序列号
    serialNumberPlaceholder: "serial number", // 请输入序列号
    equipmentAlias: "equipment alias", // 设备别名
    warrantyExpirationDate: "Warranty expiration date", // 质保到期
    serviceExpirationDate: "Service expiration date", // 服务到期
    model: "model", // 型号
    versionNumber: "version number", // 版本号
    iccid: "sim iccid", // SIM 卡号
    onlineState: "online state", // 在线状态
    isBind: "not bind passageway", // 是否绑定出入口
    bindPassageway: "bind passageway", // 绑定出入口
    transmitterPower: "Transmitter power", // 发射端电量
    receiverPower: "Receiver power", // 接收端电量
    heartbeatTime: "heartbeat time", // 心跳时间
    reportedTime: "reported time", // 最后上报时间
    learningStatus: "Learning Status", // 学习状态
}